module.exports = __webpack_public_path__ + "static/desktop-ed5536ebc82466113c4e455fac430155.svg";